export const calcDate = (startTime, startStr, endTime, endStr) => {
  if (startTime != "" && startStr != "" && endTime != "" && endStr != "") {
    var startTimeMilliseconds = Date.parse(startTime.replace(/-/g, "/"))
    var endTimeMilliseconds = Date.parse(endTime.replace(/-/g, "/"))
    if (startStr == "下午") {
      startTimeMilliseconds += 12 * 60 * 60 * 1000
    }
    if (endStr == "上午") {
      endTimeMilliseconds += 12 * 60 * 60 * 1000
    } else {
      endTimeMilliseconds += 24 * 60 * 60 * 1000
    }
    var day = (endTimeMilliseconds - startTimeMilliseconds) / (1000 * 60 * 60 * 24)
    return day
  } else {
    return 0;
  }
}

/**
 * 日期格式化
 */
export function dateFormat(date, format) {
  format = format || 'yyyy-MM-dd hh:mm:ss';
  if (date !== 'Invalid Date') {
    console.log(date.getMonth());
    let o = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      "S": date.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
      if (new RegExp("(" + k + ")").test(format))
        format = format.replace(RegExp.$1,
          RegExp.$1.length === 1 ? o[k] :
            ("00" + o[k]).substr(("" + o[k]).length));
    return format;
  }
  return '';

}
//获取周一日期
export function getMonday() {
  var day = new Date().getDay() - 1
  day = day == -1 ? 6 : day
  console.log(day)
  var monMillisec = new Date().getTime() - 1000 * 60 * 60 * 24 * day;
  var monDate = new Date(monMillisec)
  console.log(monDate)
  return monDate

}

